export default __webpack_public_path__ + "static/media/buzzer.c6584e0b.mp3";